import NotificationSolidSVG from "@design-system/ui-icons/vanilla/NotificationSolid"
import { createIcon } from "../createIcon"

export const NotificationSolidIcon = createIcon(NotificationSolidSVG)
